exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label.isOn {\n  color: darkRed;\n  font-weight: bold;\n  border: 2px solid darkRed;\n}\n\nlabel {\n  display: inline-block;\n  padding: 3px;\n  margin:3px;\n}\n\nlabel:hover {\n\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/project-db-records/project-db-records.component.css
// module id = 399
// module chunks = 0